export var HistoricalCurveElementStatus;
(function (HistoricalCurveElementStatus) {
    HistoricalCurveElementStatus[HistoricalCurveElementStatus["Normal"] = 0] = "Normal";
    HistoricalCurveElementStatus[HistoricalCurveElementStatus["Loading"] = 1] = "Loading";
    HistoricalCurveElementStatus[HistoricalCurveElementStatus["Unbound"] = 2] = "Unbound";
    HistoricalCurveElementStatus[HistoricalCurveElementStatus["LoadFailed"] = 3] = "LoadFailed";
})(HistoricalCurveElementStatus || (HistoricalCurveElementStatus = {}));
